import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

/**
 * SelectBox component.
 *
 * This component renders a dropdown select box with label and options based on provided data values.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {Array<Object>} props.dataVals - Array of objects containing 'key' and 'val' keys for each option.
 * @param {string|number} props.currentVal - Current value selected in the dropdown.
 * @param {function} props.handleVal - Function to handle changes in the select box's value.
 * @param {string} [props.label] - Label text for the dropdown (optional, defaults to an empty string).
 * @param {boolean} [props.disabled=false] - Whether the dropdown is disabled or not (optional, defaults to false).
 *
 * @returns {JSX.Element} - The JSX element for the select box.
 */
function SelectBox({ dataVals, currentVal, handleVal, label, disabled = false }) {
  const handleChange = (event) => {
    handleVal(event.target.value);
  };

  return (
    <Box sx={{ maxWidth: "100%" }}>
      <FormControl fullWidth>
        <InputLabel id="simple-select-label">{label}</InputLabel>
        <Select onChange={handleChange} value={currentVal} disabled={disabled}>
          {dataVals.map((item) => (
            <MenuItem key={item.key} value={item.key}>{`${item.val}`}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default SelectBox;
